import {
  ATTACHMENT_ACCEPT,
  VIDEO_MIME_TYPES,
  WORKSHOP_FILE_ACCEPT,
} from "@/app/routes/dashboard/api/useSessionAttachments";
import { BRAND_MEDIA_ACCEPT } from "@/app/routes/dashboard/api/useBrandMedia";

/**
 * The workshop paperclip takes images too: any other file joins the project's
 * files, an image joins its Media. Neither goes to the brand library.
 */
export const WORKSHOP_ATTACH_ACCEPT = `${WORKSHOP_FILE_ACCEPT},${BRAND_MEDIA_ACCEPT}`;
/** Phone attach sheet: "Photo or video" picks pictures and videos only. */
export const WORKSHOP_PHOTO_ACCEPT = `${BRAND_MEDIA_ACCEPT},${VIDEO_MIME_TYPES.join(",")}`;
/** Phone attach sheet: "File" picks everything else the project reads (videos too). */
export const WORKSHOP_DOC_ACCEPT = `${WORKSHOP_FILE_ACCEPT},${ATTACHMENT_ACCEPT}`;
